﻿import angular from "angular";
import _ from "lodash";
import ProductApi from "./api/product";
import "./datastorage";

angular.module("folkeuni").factory("Product", function (DataStorage, $q, $cookies, $rootScope) {
    var product = this,
        currentCategoriesFilter = null,
        currentCategories = null,
        currentCategoriesLoading = false,
        currentCategoriesPromise = null;

    var cache = {
        getCategories: [],
        getProductCategoriesByArea: []
    };

    product.attendeesGet = function (dateLocationObj) {
        var deferred = $q.defer();

        ProductApi.attendeesGet(dateLocationObj).then(
            function (attendeesObj) {
                deferred.resolve(attendeesObj);
            },
            function (errorResponse) {
                deferred.reject(errorResponse);
                console.log("error", errorResponse);
            }
        );

        return deferred.promise;
    };
    product.getKeyAccountContract = function () {
        var deferred = $q.defer();
        ProductApi.getKeyAccountContract().then(
            function (contractObj) {
                deferred.resolve(contractObj);
            },
            function (errorResponse) {
                deferred.reject(errorResponse);
            }
        );
        return deferred.promise;
    };

    product.getProductById = function (siteId, productId) {
        var deferred = $q.defer();

        var areaObj = {
            siteId: siteId,
            areaId: null,
            keyAccountOnly: false
        };
        product.getProductCategoriesByArea(areaObj).then(
            function (categories) {
                ProductApi.getProductById(siteId, productId).then(
                    function (product) {
                        var currentProduct = product;

                        for (var i in categories) {
                            var currentCategory = categories[i];

                            if (currentProduct.categoryName == currentCategory.name) {
                                currentProduct.categoryColor = currentCategory.color;
                                currentProduct.categoryUrl = currentCategory.urlName;
                            }
                        }
                        deferred.resolve(currentProduct);
                    },
                    function (res) {
                        deferred.reject(res);
                    }
                );
            },
            function (res) {
                deferred.reject(res);
            }
        );

        return deferred.promise;
    };

    product.getProduct = function (siteId, indentifier, urlExt = "") {
        var deferred = $q.defer();
        var areaObj = {
            siteId: siteId,
            areaId: null,
            keyAccountOnly: false
        };
        product.getProductCategoriesByArea(areaObj).then(
            function (categories) {
                ProductApi.getProduct(siteId, indentifier, urlExt).then(
                    function (product) {
                        if (product) {
                            var currentProduct = product;

                            for (var i in categories) {
                                var currentCategory = categories[i];

                                if (currentProduct.categoryName == currentCategory.name) {
                                    currentProduct.categoryColor = currentCategory.color;
                                    currentProduct.categoryUrl = currentCategory.urlName;
                                }
                            }
                            //currentProduct.ended = true;

                            for (var y = 0; y < currentProduct.courses.length; y++) {
                                for (var i = 0; i < currentProduct.courses[y].events.length; i++) {
                                    var currentEvent = currentProduct.courses[y].events[i];

                                    if (new Date() < new Date(currentEvent.endDate)) {
                                        currentProduct.ended == false;
                                        break;
                                    }
                                }
                            }

                            deferred.resolve(currentProduct);
                        } else {
                            deferred.reject(product);
                        }
                    },
                    function (res) {
                        deferred.reject(res);
                    }
                );
            },
            function (res) {
                deferred.reject(res);
            }
        );

        return deferred.promise;
    };

    product.getCategories = function (siteId, voucherActive) {
        var categoryCache = _.find(cache.getCategories, { siteId: siteId, voucherActive: voucherActive });
        if (!categoryCache) {
            categoryCache = {
                siteId: siteId,
                voucherActive: voucherActive,
                deferred: null,
                loading: false,
                value: null
            };
            cache.getCategories.push(categoryCache);
        }

        var deferred = categoryCache.deferred ? categoryCache.deferred : $q.defer();

        if (!categoryCache.loading && categoryCache.value !== null) {
            deferred.resolve(categoryCache.value);
        } else if (!categoryCache.loading) {
            categoryCache.loading = true;
            categoryCache.deferred = deferred;

            ProductApi.getCategories(siteId, voucherActive).then(
                function (res) {
                    categoryCache.value = res;
                    deferred.resolve(categoryCache.value);
                    categoryCache.loading = false;
                },
                function (res) {
                    deferred.reject(res);
                    categoryCache.loading = false;
                }
            );
        }

        return deferred.promise;
    };

    product.getProductCategoriesByArea = function (areaObj) {
        var categoryCache = _.find(cache.getProductCategoriesByArea, {
            areaId: areaObj.areaId,
            siteId: areaObj.siteId,
            voucherActive: areaObj.keyAccountOnly
        });
        if (!categoryCache) {
            categoryCache = {
                areaId: areaObj.areaId,
                siteId: areaObj.siteId,
                voucherActive: areaObj.keyAccountOnly,
                deferred: null,
                loading: false,
                value: null
            };
            cache.getProductCategoriesByArea.push(categoryCache);
        }

        var deferred = categoryCache.deferred ? categoryCache.deferred : $q.defer();

        if (!categoryCache.loading && categoryCache.value !== null) {
            deferred.resolve(categoryCache.value);
        } else if (!categoryCache.loading) {
            categoryCache.loading = true;
            categoryCache.deferred = deferred;

            ProductApi.getCategoriesByArea(areaObj).then(
                function (res) {
                    categoryCache.value = res;
                    deferred.resolve(categoryCache.value);
                    categoryCache.loading = false;
                },
                function (res) {
                    deferred.reject(res);
                    categoryCache.loading = false;
                }
            );
        }
        return deferred.promise;
    };
    product.getProductsById = function (siteId, productIdArray, urlExt = "") {
        var deferred = $q.defer();

        var searchObj = {
            siteId: siteId,
            products: productIdArray
        };

        ProductApi.getProductsById({ data: searchObj, urlExt }).then(
            function (searchResult) {
                deferred.resolve(searchResult);
            },
            function (errorResponse) {
                deferred.reject(errorResponse);
            }
        );

        return deferred.promise;
    };
    product.getProductsByCategory = function ({ searchObj, urlExt }) {
        var deferred = $q.defer();

        var areaObj = {
            siteId: searchObj.siteId,
            areaId: searchObj.areaId,
            keyAccountOnly: searchObj.keyAccountOnly
        };

        product.getProductCategoriesByArea(areaObj).then(
            function (categories) {
                ProductApi.getProducts({ searchObj, urlExt }).then(
                    function (searchResult) {
                        var products = searchResult;

                        for (var i in products.notStarted) {
                            var currentProduct = products.notStarted[i];

                            for (var y in categories) {
                                var currentCategory = categories[y];
                                if (currentCategory.urlName == currentProduct.categoryUrlName) {
                                    currentProduct.categoryColor = currentCategory.color;
                                    currentProduct.categoryName = currentCategory.name;
                                    break;
                                }
                            }
                        }
                        for (var i in products.started) {
                            var currentProduct = products.started[i];

                            for (var y in categories) {
                                var currentCategory = categories[y];
                                if (currentCategory.urlName == currentProduct.categoryUrlName) {
                                    currentProduct.categoryColor = currentCategory.color;
                                    currentProduct.categoryName = currentCategory.name;
                                    break;
                                }
                            }
                        }
                        deferred.resolve(products);
                    },
                    function (res) {
                        deferred.reject(res);
                    }
                );
            },
            function (errorResponse) {}
        );
        return deferred.promise;
    };

    product.getProductsByCategoryCount = function (searchObj) {
        var deferred = $q.defer();

        var areaObj = {
            siteId: searchObj.siteId,
            areaId: searchObj.areaId,
            keyAccountOnly: searchObj.keyAccountOnly
        };

        product.getProductCategoriesByArea(areaObj).then(
            function (categories) {
                ProductApi.getProductsCount(searchObj).then(
                    function (searchResult) {
                        deferred.resolve(searchResult);
                    },
                    function (res) {
                        deferred.reject(res);
                    }
                );
            },
            function (errorResponse) {}
        );
        return deferred.promise;
    };

    product.getActiveWeekdays = function (areaObj) {
        var deferred = $q.defer();

        if (areaObj.areaId) {
            ProductApi.getActiveWeekdays(areaObj).then(
                function (weekdays) {
                    deferred.resolve(weekdays);
                },
                function (res) {
                    deferred.reject(res);
                }
            );
        } else {
            deferred.resolve(product.weekdaysArray);
        }
        return deferred.promise;
    };

    product.locationsGetBySiteId = function (siteId) {
        var deferred = $q.defer();
        ProductApi.locationsGetBySiteId(siteId).then(
            function (locationsObj) {
                for (var i = locationsObj.length - 1; i >= 0; i--) {
                    var currentLocation = locationsObj[i];

                    if (!currentLocation.name) {
                        locationsObj.splice(i, 1);
                    }
                }
                deferred.resolve(locationsObj);
            },
            function (errorResponse) {
                deferred.reject(errorResponse);
            }
        );

        return deferred.promise;
    };

    product.ticketStatus = function (departmentId, product) {
        var deferred = $q.defer();
        var ended = true;
        var manualOverride = false;

        if (!product.courses) {
            for (var i = 0; i < product.events.length; i++) {
                manualOverride = true;
                var currentEvent = product.events[i];

                if (new Date() < new Date(currentEvent.endDate)) {
                    ended = false;
                    break;
                }
            }
        } else {
            for (var y = 0; y < product.courses.length; y++) {
                manualOverride = true;
                for (var i = 0; i < product.courses[y].events.length; i++) {
                    var currentEvent = product.courses[y].events[i];

                    if (new Date() < new Date(currentEvent.endDate)) {
                        ended = false;
                        break;
                    }
                }
            }
        }

        if (typeof product.ended !== "undefined" && !manualOverride) {
            ended = product.ended;
        }

        if (product.cancelled && !ended) {
            product.ticketStatus = {
                class: "cancelled",
                title: "AFLYST"
            };
        } else if (product.available == 0) {
            product.ticketStatus = {
                class: "soldOut",
                title: "VENTELISTE"
            };
        } else if (
            (product.available > 0 && (product.available / Number(product.maxAttendance) < 0.2)) ||
            product.fewAvailable ||
            (product.courses && product.courses.length > 0 && product.courses[0].fewAvailable)
        ) {
            product.ticketStatus = {
                class: "fewLeft",
                title: "FÅ PLADSER"
            };
        }

        deferred.resolve(product);
        return deferred.promise;
    };

    //Flyttes til service/products-list?
    product.programFilterSetLocalHost = function (searchFilter) {
        var localStorageObj = { ...searchFilter };

        DataStorage.set("programfilter", JSON.stringify(localStorageObj));
    };

    product.searchFilterWeekdaysReset = function (searchFilter, weekdays) {
        var deferred = $q.defer();
        for (var i = 0; weekdays.length > i; i++) {
            var currentWeekday = weekdays[i];
            currentWeekday.active = false;
        }

        searchFilter.weekdays = null;
        product.programFilterSetLocalHost(searchFilter);

        const updatedObj = {
            searchFilter: searchFilter,
            weekdays: weekdays
        };

        deferred.resolve(updatedObj);
        return deferred.promise;
    };
    product.searchFilterWeekdaysUpdate = function (searchFilter, weekdays, weekdayToUpdate) {
        var deferred = $q.defer();

        searchFilter.weekdays = null;
        // - searchfilter kører ik

        for (var i = 0; weekdays.length > i; i++) {
            var currentWeekday = weekdays[i];
            if (currentWeekday.value == weekdayToUpdate) {
                currentWeekday.active = !currentWeekday.active;
            }
            if (currentWeekday.active) {
                if (!searchFilter.weekdays) {
                    searchFilter.weekdays = [currentWeekday.value];
                } else {
                    searchFilter.weekdays.push(currentWeekday.value);
                }
            }
        }
        //Noget går galt her?!
        product.programFilterSetLocalHost(searchFilter);

        const updatedObj = {
            searchFilter: searchFilter,
            weekdays: weekdays
        };

        deferred.resolve(updatedObj);
        return deferred.promise;
    };

    product.searchFilterFromLocalStorage = function (searchFilter, weekdayArray, getArea) {
        var deferred = $q.defer();
        var weekdaysFromLocalStorage = [];
        var returnObj = {
            searchFilter: searchFilter,
            weekdayArray: weekdayArray
        };

        var programFilterFromLocalStorage = null;

        DataStorage.get("programfilter").then(
            function (data) {
                programFilterFromLocalStorage = data;
                if (programFilterFromLocalStorage) {
                    var programFilterFromLocalStorageAsJSON = JSON.parse(programFilterFromLocalStorage);
                    if (programFilterFromLocalStorageAsJSON.weekdays) {
                        weekdaysFromLocalStorage = programFilterFromLocalStorageAsJSON.weekdays;
                    }
                    if (programFilterFromLocalStorageAsJSON.orderBy) {
                        returnObj.searchFilter.orderBy = programFilterFromLocalStorageAsJSON.orderBy;
                    }
                    if (programFilterFromLocalStorageAsJSON.keyAccountOnly) {
                        returnObj.searchFilter.keyAccountOnly = programFilterFromLocalStorageAsJSON.keyAccountOnly;
                    }

                    if (getArea) {
                        if (programFilterFromLocalStorageAsJSON.areaId) {
                            returnObj.searchFilter.areaId = programFilterFromLocalStorageAsJSON.areaId;
                        }
                        if (programFilterFromLocalStorageAsJSON.siteId) {
                            returnObj.searchFilter.siteId = programFilterFromLocalStorageAsJSON.siteId;
                        }
                    }
                }

                for (var i = 0; returnObj.weekdayArray.length > i; i++) {
                    var currentWeekday = returnObj.weekdayArray[i];
                    for (var y = 0; weekdaysFromLocalStorage.length > y; y++) {
                        var currentWeekdayFromLocalStorage = weekdaysFromLocalStorage[y];

                        if (currentWeekday.value == currentWeekdayFromLocalStorage) {
                            currentWeekday.active = true;

                            if (!returnObj.searchFilter.weekdays) {
                                returnObj.searchFilter.weekdays = [currentWeekday.value];
                            } else {
                                returnObj.searchFilter.weekdays.push(currentWeekday.value);
                            }
                        }
                    }
                }
            },
            function (message) {}
        );

        deferred.resolve(returnObj);
        return deferred.promise;
    };

    product.isFavorite = function (productId) {
        var deferred = $q.defer();

        if (productId) {
            DataStorage.get("favoriteList").then(
                function (data) {
                    var list = JSON.parse(data);
                    var exists = false;
                    for (var i = 0; i < list.length; i++) {
                        if (list[i].id === productId) {
                            exists = true;
                            break;
                        }
                    }
                    deferred.resolve(exists);
                },
                function () {
                    deferred.resolve(false);
                }
            );
        } else {
            deferred.resolve(false);
        }

        return deferred.promise;
    };

    product.removeAsFavorite = function (id) {
        var deferred = $q.defer();

        if (id) {
            DataStorage.get("favoriteList").then(
                function (data) {
                    var list = JSON.parse(data);

                    for (var i = 0; i < list.length; i++) {
                        if (list[i].id === id) {
                            list.splice(i, 1);
                        }
                    }

                    DataStorage.set("favoriteList", JSON.stringify(list)).then(function () {
                        deferred.resolve(list);
                    });
                },
                function () {
                    deferred.resolve(null);
                }
            );
        } else {
            deferred.resolve(null);
        }

        return deferred.promise;
    };

    product.weekdaysArray = [
        {
            value: 2,
            weekday: "Mandag"
        },
        {
            value: 3,
            weekday: "Tirsdag"
        },
        {
            value: 4,
            weekday: "Onsdag"
        },
        {
            value: 5,
            weekday: "Torsdag"
        },
        {
            value: 6,
            weekday: "Fredag"
        },
        {
            value: 7,
            weekday: "Lørdag"
        },
        {
            value: 1,
            weekday: "Søndag"
        }
    ];

    return product;
});
